import React from 'react';
import * as XLSX from 'xlsx';

const PrimaryModuleCalibration = () => {
  const inspectionData = JSON.parse(sessionStorage.getItem('inspectionData') || '{}');
  const calibrationData = inspectionData.PrimaryModuleCalibrationRecord;

  if (!calibrationData || !calibrationData.date || !calibrationData.lines) {
    return <p className="text-gray-500">No Primary Module Calibration data available</p>;
  }

  // Function to download data as Excel
  const downloadExcel = () => {
    const workbook = XLSX.utils.book_new();
    const worksheetData = [];

    // Headers for the Excel sheet
    worksheetData.push([
      'Line',
      'Module Serial Number',
      'Golden Module Report',
      'Alpha Value',
      'Beta Value',
      'Gamma Value',
      'Measured FF',
      'Measured IMP',
      'Measured ISC',
      'Measured Pmax',
      'Measured VMP',
      'Measured VOC',
      'Nominal FF',
      'Nominal IMP',
      'Nominal ISC',
      'Nominal Pmax',
      'Nominal VMP',
      'Nominal VOC',
    ]);

    // Populate data for each line
    Object.entries(calibrationData.lines).forEach(([lineKey, lineData]) => {
      worksheetData.push([
        lineKey,
        lineData.moduleSerialNumber,
        lineData.goldenModuleReport,
        lineData.alphaValue,
        lineData.betaValue,
        lineData.gammaValue,
        lineData.measuredFF,
        lineData.measuredIMP,
        lineData.measuredISC,
        lineData.measuredPmax,
        lineData.measuredVMP,
        lineData.measuredVOC,
        lineData.nominalFF,
        lineData.nominalIMP,
        lineData.nominalISC,
        lineData.nominalPmax,
        lineData.nominalVMP,
        lineData.nominalVOC,
      ]);
    });

    const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
    XLSX.utils.book_append_sheet(workbook, worksheet, 'PrimaryModuleCalibration');
    XLSX.writeFile(workbook, 'PrimaryModuleCalibrationData.xlsx');
  };

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-2xl font-semibold text-gray-800">
          Primary Module Calibration Data - {calibrationData.date}
        </h2>
        <button
          onClick={downloadExcel}
          className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 focus:outline-none"
        >
          Download Excel
        </button>
      </div>

      {Object.entries(calibrationData.lines).map(([lineKey, lineData]) => (
        <div key={lineKey} className="border-b pb-4">
          <h3 className="text-xl font-semibold text-gray-800 mb-4">{lineKey}</h3>

          {/* Scalar Fields */}
          <div className="mt-4">
            <h4 className="font-semibold text-gray-700 mb-2">Details</h4>
            <div className="grid grid-cols-2 gap-4">
              <p><strong>Module Serial Number:</strong> {lineData.moduleSerialNumber || 'N/A'}</p>
              <p><strong>Golden Module Report:</strong> {lineData.goldenModuleReport || 'N/A'}</p>
              <p><strong>Alpha Value:</strong> {lineData.alphaValue || 'N/A'}</p>
              <p><strong>Beta Value:</strong> {lineData.betaValue || 'N/A'}</p>
              <p><strong>Gamma Value:</strong> {lineData.gammaValue || 'N/A'}</p>
            </div>
          </div>

          {/* Measured and Nominal Values */}
          <div className="mt-4">
            <h4 className="font-semibold text-gray-700 mb-2">Calibration Values</h4>
            <div className="overflow-x-auto">
              <table className="min-w-full bg-white border rounded-lg">
                <thead>
                  <tr className="bg-gray-100">
                    <th className="px-4 py-2 text-left text-gray-700">Parameter</th>
                    <th className="px-4 py-2 text-left text-gray-700">Measured</th>
                    <th className="px-4 py-2 text-left text-gray-700">Nominal</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="border-t">
                    <td className="px-4 py-2 text-gray-600">FF</td>
                    <td className="px-4 py-2 text-gray-600">{lineData.measuredFF || 'N/A'}</td>
                    <td className="px-4 py-2 text-gray-600">{lineData.nominalFF || 'N/A'}</td>
                  </tr>
                  <tr className="border-t">
                    <td className="px-4 py-2 text-gray-600">IMP</td>
                    <td className="px-4 py-2 text-gray-600">{lineData.measuredIMP || 'N/A'}</td>
                    <td className="px-4 py-2 text-gray-600">{lineData.nominalIMP || 'N/A'}</td>
                  </tr>
                  <tr className="border-t">
                    <td className="px-4 py-2 text-gray-600">ISC</td>
                    <td className="px-4 py-2 text-gray-600">{lineData.measuredISC || 'N/A'}</td>
                    <td className="px-4 py-2 text-gray-600">{lineData.nominalISC || 'N/A'}</td>
                  </tr>
                  <tr className="border-t">
                    <td className="px-4 py-2 text-gray-600">Pmax</td>
                    <td className="px-4 py-2 text-gray-600">{lineData.measuredPmax || 'N/A'}</td>
                    <td className="px-4 py-2 text-gray-600">{lineData.nominalPmax || 'N/A'}</td>
                  </tr>
                  <tr className="border-t">
                    <td className="px-4 py-2 text-gray-600">VMP</td>
                    <td className="px-4 py-2 text-gray-600">{lineData.measuredVMP || 'N/A'}</td>
                    <td className="px-4 py-2 text-gray-600">{lineData.nominalVMP || 'N/A'}</td>
                  </tr>
                  <tr className="border-t">
                    <td className="px-4 py-2 text-gray-600">VOC</td>
                    <td className="px-4 py-2 text-gray-600">{lineData.measuredVOC || 'N/A'}</td>
                    <td className="px-4 py-2 text-gray-600">{lineData.nominalVOC || 'N/A'}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default PrimaryModuleCalibration;